import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { getAllUrls } from "../redux/actions/urlsAction";
import Loading from "./Loading";
import PageNotFound from "./404page";

const RenderOtherPages = () => {
  const urls = useSelector((state) => state.urls);

  const dispatch = useDispatch();

  const location = useLocation();

  React.useEffect(() => {
    dispatch(getAllUrls({ filters: { is_delete: false } }));
  }, [dispatch]);

  if (urls.loading) {
    return <Loading />;
  }
  if (urls.data?.length > 0) {
    const index = urls.data?.findIndex(
      (i) => i?.origin_url === location.pathname
    );
    if (index >= 0) {
       return <Navigate to={`/${urls.data[index]?.target_url}`} />;
    } else {
      return <PageNotFound />;
    }
  }
};

export default RenderOtherPages;
